export const formatDateTime = (dateTimeString: string) => {
  const date = new Date(dateTimeString);
  const day = date.getDate();
  const month = date.toLocaleDateString("en-US", { month: "short" });
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${day} ${month} · ${hours}:${minutes}`;
};
